// @ts-nocheck
/* tslint:disable */
/* eslint-disable */
/**
 * OpenAPI definition
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: v0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { mapValues } from '../runtime';
/**
 * 
 * @export
 * @interface IResendConfirmationCodeRequestDto
 */
export interface IResendConfirmationCodeRequestDto {
    /**
     * 
     * @type {string}
     * @memberof IResendConfirmationCodeRequestDto
     */
    username: string;
}

/**
 * Check if a given object implements the IResendConfirmationCodeRequestDto interface.
 */
export function instanceOfIResendConfirmationCodeRequestDto(value: object): value is IResendConfirmationCodeRequestDto {
    if (!('username' in value) || value['username'] === undefined) return false;
    return true;
}

export function IResendConfirmationCodeRequestDtoFromJSON(json: any): IResendConfirmationCodeRequestDto {
    return IResendConfirmationCodeRequestDtoFromJSONTyped(json, false);
}

export function IResendConfirmationCodeRequestDtoFromJSONTyped(json: any, ignoreDiscriminator: boolean): IResendConfirmationCodeRequestDto {
    if (json == null) {
        return json;
    }
    return {
        
        'username': json['username'],
    };
}

export function IResendConfirmationCodeRequestDtoToJSON(json: any): IResendConfirmationCodeRequestDto {
    return IResendConfirmationCodeRequestDtoToJSONTyped(json, false);
}

export function IResendConfirmationCodeRequestDtoToJSONTyped(value?: IResendConfirmationCodeRequestDto | null, ignoreDiscriminator: boolean = false): any {
    if (value == null) {
        return value;
    }

    return {
        
        'username': value['username'],
    };
}

